import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import refreshOrdering from '../assets/icons/refreshOrdering.svg';
import PresentationController from '../controllers/PresentationController';
import { svgToIcon } from '../utils/svg';
import styles from './presentations.module.css';

const SidePanelTitle: React.FC = () => {
  const controller = useController(PresentationController);
  const frames = controller.getFrames(true);
  const hiddenFrames = frames.filter(frame => !frame.getVisibility());

  return (
    <div className={styles.framesSidePanelTitle}>
      {controller.hasOrderedFrames() && (
        <>
          <button
            className={styles.resetFrameOrder}
            onClick={() => {
              controller.resetFrameOrder();
            }}
          >
            {svgToIcon(refreshOrdering)}
          </button>
          <aha-tooltip>Reset slide order</aha-tooltip>
        </>
      )}

      <p className={styles.frameCount}>
        <span>
          <span className={styles.number}> {frames.length}</span> Frame
          {frames.length !== 1 ? 's' : ''}
        </span>
        {hiddenFrames.length ? (
          <span>
            <span className={styles.number}>{hiddenFrames.length}</span> Hidden
          </span>
        ) : null}
      </p>
    </div>
  );
};

export default ApplicationView(SidePanelTitle);
